//------------------------------------
// normalize characteristic skill adjs
//------------------------------------
export default function normalizeCharacteristicSkillAdjs(adjs = []) {
  if (!Array.isArray(adjs)) return []

  return adjs.map((adj) => {
    const name = String(adj?.name ?? adj?.characteristic_name ?? '')
      .toLowerCase()
      .trim()

    const reason = String(adj?.adj_reason ?? '').trim()
    const isLegacyArmourDexPenalty = name === 'dex' && reason.toLowerCase() === 'armour dex penalty'

    const characterItem =
      typeof adj?.character_item === 'object'
        ? (adj.character_item?.id ?? null)
        : (adj?.character_item ?? null)

    return {
      ...adj,
      name,
      characteristic_name: name,
      character_item: characterItem,
      adj_armour: adj?.adj_armour ?? isLegacyArmourDexPenalty,
      applied: adj?.applied ?? true,
      editable: adj?.editable ?? !(adj?.adj_armour ?? isLegacyArmourDexPenalty),
      rune: adj?.rune ?? '',
      source: adj?.source ?? 'characteristic-skill',
    }
  })
}
